import React, { Component } from 'react'
import * as R from 'ramda'
import { observer } from 'mobx-react'
import i18n from 'i18next'

import Modal from '../../../UniformComponents/Modal'
import ModalHeader from '../../../UniformComponents/ModalHeader'
import Button from '../../../UniformComponents/Button'

@observer
class LinkedIn extends Component {
    constructor(props) {
        super(props)
        this.state = {
            status: 'authorizing',
            creatingPost: false,
        }
    }

    componentDidMount() {
        window.addEventListener('message', this.onMessage)
    }

    componentWillUnmount() {
        window.removeEventListener('message', this.onMessage)
    }

    

    onMessage = async ({ data }) => {
        const { certificationStore } = this.props
        this.popUp.close()
        try {
            const json = JSON.parse(data)
            if (R.hasPath(['code'], json)) {
                const { code: token } = json
                const { urn } = await certificationStore.getURNLinkedIn(token)
                this.setState({
                    status: 'ready',
                    token,
                    urn,
                })
            } else {
                this.setState({
                    status: 'error',
                })
            }
        } catch (e) {
            console.error(e)
            this.setState({
                status: 'error',
            })
        }
    }

    createPost = async () => {
        const { comment, urn, token } = this.state
        const { certificationStore } = this.props

        this.setState({ creatingPost: true})
        await certificationStore.createPostLinkedIn(comment, urn, token)
        this.setState({ creatingPost: false})
        certificationStore.onCloseLinkedIn()
    }

    showPopup = () => {
        const width = 450
        const height = 730
        const left = window.screen.width / 2 - width / 2
        const top = window.screen.height / 2 - height / 2

        this.popUp = window.open(
            process.env.LINKEDIN_AUTH_URL,
            'Linkedin',
            `menubar=no,location=no,resizable=no,scrollbars=no,status=no, width=${width}, height=${height}, left=${left}, top=${top}`,
        )
        return null
    }

    render() {
        const { status, creatingPost } = this.state
        const { certificationStore } = this.props
        const { showLinkedIn } = certificationStore

        if (!showLinkedIn) return null

        return (
            <Modal
                cssClass="linkedin"
                show={showLinkedIn}
                onClose={certificationStore.onCloseLinkedIn}
                style={{
                    minHeight: '670px',
                    minWidth: '800px',
                }}
            >
                <ModalHeader>
                    <h3>{i18n.t('certification.modal.title')}</h3>
                </ModalHeader>
                <div>
                    {status === 'authorizing' && (
                        this.showPopup()
                    )}
                    {status === 'error' && (
                        <div>
                            {i18n.t('certification.modal.loginError')}
                        </div>
                    )}
                    {status === 'ready' && (
                        <div
                            style={{
                                display: 'flex',
                                gap: '10px',
                                flexDirection: 'column',
                            }}
                        >
                            <div
                                className="linkedin_post"
                            >
                                <textarea
                                    placeholder={i18n.t('certification.modal.placeholder')}
                                    onBlur={(e) => { this.setState({ comment: e.target.value }) }}
                                />
                                <img src={certificationStore.certifiateAsURL()} />
                            </div>
                            <div
                                style={{
                                    textAlign: 'right',
                                }}
                            >
                                <Button
                                    disabled={creatingPost}
                                    label={i18n.t('certification.modal.post')}
                                    onClick={this.createPost}
                                />
                            </div>
                        </div>
                    )}
                </div>
            </Modal>
        )
    }
}

export default LinkedIn
